import { FormControl } from '@angular/forms';

export function validateUsername(c: FormControl) {
  const test = /^[a-zA-Z][a-zA-Z0-9\_\-]*$/.test(c.value);

  return !c.value || test ? null : {
    validUsername: {
      valid: false
    }
  };
}
